module.exports = __webpack_public_path__ + "static/media/safe-zone-16-9.98838e9a.png";